import moment from "moment-timezone";
import { FC } from "react";

interface Props {
    value: Date;
    timezone: string | null;
}

const WalletTableLastUpdateCell: FC<Props> = ({ value, timezone }) => {
    return (
        <div className="flex items-center justify-start gap-2">
            {moment(value)
                .tz(timezone ?? "UTC")
                .fromNow()}
        </div>
    );
};

export default WalletTableLastUpdateCell;
